import { TTaskData } from "../types/task";

export interface FilterCriteria {
	responsible_roles?: string[];
	accountable_roles?: string[];
	consulted?: string[];
	informed_parties?: string[];
	status?: string[];
}

export const filterTasks = (
	tasks: TTaskData[],
	filters: FilterCriteria
): TTaskData[] => {
	if (!filters || Object.keys(filters).length === 0) {
		return tasks;
	}

	return tasks.filter((task) => {
		// Filter by status
		if (filters.status && filters.status.length > 0) {
			if (!filters.status.includes(task.status)) {
				return false;
			}
		}

		// Filter by responsible roles
		if (filters.responsible_roles && filters.responsible_roles.length > 0) {
			const taskResponsibleRoles = task.responsible_roles || [];
			const hasMatchingResponsibleRole = filters.responsible_roles.some(
				(roleId) => taskResponsibleRoles.includes(roleId)
			);
			if (!hasMatchingResponsibleRole) {
				return false;
			}
		}

		// Filter by accountable roles
		if (filters.accountable_roles && filters.accountable_roles.length > 0) {
			const taskAccountableRoles = task.accountable_roles || [];
			const hasMatchingAccountableRole = filters.accountable_roles.some(
				(roleId) => taskAccountableRoles.includes(roleId)
			);
			if (!hasMatchingAccountableRole) {
				return false;
			}
		}

		// Filter by consulted roles
		if (filters.consulted && filters.consulted.length > 0) {
			const taskConsultedRoles = task.consulted || [];
			const hasMatchingConsultedRole = filters.consulted.some((roleId) =>
				taskConsultedRoles.includes(roleId)
			);
			if (!hasMatchingConsultedRole) {
				return false;
			}
		}

		// Filter by informed parties
		if (filters.informed_parties && filters.informed_parties.length > 0) {
			const taskInformedParties = task.informed_parties || [];
			const hasMatchingInformedParty = filters.informed_parties.some((roleId) =>
				taskInformedParties.includes(roleId)
			);
			if (!hasMatchingInformedParty) {
				return false;
			}
		}

		return true;
	});
};

export const hasActiveFilters = (filters: FilterCriteria): boolean => {
	if (!filters) return false;

	return Object.values(filters).some(
		(filterArray) => Array.isArray(filterArray) && filterArray.length > 0
	);
};
